import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {RoutedTaskMarker} from "../../models/routed-task-marker.model";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {MapsCommonService} from "../../services/mapsCommon.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {TaskType} from "../../../tasks/types/task.type";

export class RouteMapComponent implements IController {
  tasks: any;
  agent: any;
  suggestedServices: any;
  selectedTaskId: any;
  selectedSuggestionIds: any;
  polylineColor: any;
  isEditable: any;
  serviceAreas: any;
  onSelectTask: Function;
  onSelectSuggestion: Function;
  onChange: Function;

  private siteLocation: any;
  private polylineCopy: any = undefined
  private filters: any = {
    traffic: false,
    suggestions: false,
    tasks: true,
    serviceAreas: true
  };
  private map: any;
  private polyline: any;
  private polylineDraw = {
    path: [],
    visible: true,
    clickable: false,
    stroke: {
      color: '#FBB446',
      weight: 3,
      opacity: 0.7
    }
  };
  private agentMarker: any;
  private taskMarkers = [];
  private suggestionsMarkers = [];
  private locationQuery = undefined;
  private markerEvents: any;
  private isReady: boolean;
  private drawing: any;
  private drawingFromMarkerId: any;
  private firstCoords: any;
  private mapInstance: any;
  private activeWindow: any;
  private activeWindowModel: RoutedTaskMarker;
  public mapPolygons: any;

  constructor(private mapsCommonService: MapsCommonService, private resizeService: ResizeService, private deliveriesService: DeliveriesService,
              private uiGmapIsReady, private $timeout: ITimeoutService, private $mdMedia, private tasksService: TasksService) {
  }

  $onInit() {
    this.activeWindow = this.mapsCommonService.initActiveWindow();
    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      events: {
        idle: (map) => {
          if (!this.isReady) {
            this.isReady = true;
            google.maps.event.trigger(map, 'resize');
            this.resizeService.resize();
            this.centerMap();
          }
        }
      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        scaleControl: true,
        mapTypeControl: false
      },
      bounds: {},
      control: {}
    };
    this.polyline = {
      path: [],
      visible: true,
      stroke: {
        color: this.polylineColor || '#2196F3',
        weight: 2,
        opacity: 1
      },
      icons: [{
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
        },
        offset: '50px',
        repeat: '100px'
      }]
    };
    this.agentMarker = {
      options: {
        icon: this.mapsCommonService.getAgentIcon(this.agent),
        visible: true
      }
    };
    this.markerEvents = {
      click: (marker, event, model, args) => {
        var task = marker.model;
        this.onSelectSuggestion({serviceId: task.serviceId})
      },
      mousedown: (marker, event, model, args) => {
        if (this.isEditable && (model.taskType !== TaskType.Internal)) {
          const map = marker.map;
          this.drawing = true;
          this.drawingFromMarkerId = model.id;
          this.firstCoords = {latitude: marker.position.lat(), longitude: marker.position.lng()};
          map.setOptions({draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true});
        }
      },
      mouseover: (marker, event, model, args) => {
        this.activateInfoWindow(model);

        if (this.drawing && this.drawingFromMarkerId !== model.id) {

          const filteredTaskMarkers = _.filter(this.taskMarkers, (m) => {
            return m.id !== model.id;
          });
          const drawingFromMarkerIndex = _.findIndex(filteredTaskMarkers, (m) => {
            return m.id === this.drawingFromMarkerId;
          });
          const requestedTaskIndex = drawingFromMarkerIndex + 1;
          filteredTaskMarkers.splice(requestedTaskIndex, 0, model);

          const updatedTaskMarkers = filteredTaskMarkers;

          // var complementaryTaskIndex = _.findIndex(updatedTaskMarkers, function(m) {
          //     return _serviceIdsTest(models.serviceIds, m.serviceIds) && m.id !== models.id;
          // });
          var complementaryTaskIndex = this.tasksService.getComplementaryTaskIndex(model, updatedTaskMarkers);

          if (_.isEqual(this.taskMarkers, updatedTaskMarkers) ||
            !this.isHeadingOrArrivedOrderCurrect(updatedTaskMarkers)) {
            return;
          }

          if (complementaryTaskIndex === -1 ||
            (model.taskSpec.purpose === 'Pickup' && requestedTaskIndex < complementaryTaskIndex) ||
            (model.taskSpec.purpose === 'Dropoff' && requestedTaskIndex > complementaryTaskIndex)) {

            this.polylineCopy = angular.copy(this.polyline);
            this.polyline.path = this.getPolylinePath(updatedTaskMarkers);
          }

        }
      },
      mouseout: (marker, event, model, args) => {
        this.clearActiveWindow();
        if (this.drawing && this.polylineCopy) {
          this.polyline = this.polylineCopy;
          this.polylineCopy = undefined;
        }
      }
    };
    this.uiGmapIsReady.promise(1).then((maps) => {
      // Init drawing listener
      this.mapInstance = this.map.control.getGMap();
      google.maps.event.addListener(this.mapInstance, 'mousemove', (event) => {
        const isDesktop = this.$mdMedia('gt-sm');
        if (this.drawing && isDesktop) {
          this.polylineDraw.path = [
            this.firstCoords, {latitude: event.latLng.lat(), longitude: event.latLng.lng()}
          ];
          this.$timeout(0).then(() => {
          })
        }
      });
    });
    this.initItinerary(true);
    if (this.suggestedServices) {
      this.setSuggestedTasks(this.suggestedServices)
    }

    if (_.get(this.serviceAreas, 'length')) {
      this.mapPolygons = this.mapsCommonService.buildPolygons(this.serviceAreas, this.filters.serviceAreas);
    }
  }

  $onChanges(changes) {
    if (changes.tasks && !changes.tasks.isFirstChange()) {
      this.initItinerary()
    }

    if (changes.isEditable && !changes.isEditable.isFirstChange()) {
      this.initItinerary()
    }

    if (changes.selectedTaskId && !changes.selectedTaskId.isFirstChange()) {
      // var selectedTaskMarker = _.find(this.taskMarkers, (taskMarker) => {
      //   return taskMarker.id === this.selectedTaskId;
      // });
      //
      // if (selectedTaskMarker) {
      //   this.activateInfoWindow(selectedTaskMarker);
      // }
    }

    if (changes.suggestedServices && !changes.suggestedServices.isFirstChange()) {
      const suggestedServicesCurrentValue = _.get(changes, 'suggestedServices.currentValue', []),
        suggestedServicesPreviousValue = _.get(changes, 'suggestedServices.previousValue', []);

      if (suggestedServicesCurrentValue.length !== suggestedServicesPreviousValue.length) {
        this.setSuggestedTasks(this.suggestedServices)
      }
    }

    if (changes.selectedSuggestionIds && !changes.selectedSuggestionIds.isFirstChange()) {
      _.forEach(this.suggestionsMarkers, (suggestionMarker) => {
        const isSelected = _.includes(this.selectedSuggestionIds, suggestionMarker.serviceId);
        suggestionMarker.icon = this.mapsCommonService.getTaskMarkerIcon(suggestionMarker.taskSpec.purpose, suggestionMarker.status, isSelected)
      });
    }

    if (_.get(this.serviceAreas, 'length')) {
      this.mapPolygons = this.mapsCommonService.buildPolygons(this.serviceAreas, this.filters.serviceAreas);
    }
  }

  onMouseUp(event) {
    if (this.drawing) {

      this.polylineDraw.path = [];
      this.drawing = false;
      this.drawingFromMarkerId = undefined;
      this.mapInstance.setOptions({
        draggable: true,
        zoomControl: true,
        scrollwheel: true,
        disableDoubleClickZoom: false
      });

      if (this.polylineCopy) {
        const taskIds = _
          .chain(this.polyline.path)
          .map(function (path) {
            return path.id;
          })
          .value();

        const tasks = taskIds.map((id) => {
          return this.tasks.find(t => t.id === id);
        })

        this.tasks.forEach((t: TaskModel, index) => {
          const taskIndex = tasks.findIndex((task: TaskModel) => {
            return task.id === t.id;
          })
          if (taskIndex === -1) {
            tasks.splice(index, 0, t);
          }
        })

        this.polylineCopy = undefined;
        this.onChange({tasks: tasks});
      }

    }
  }

  centerMap() {
    const markers = this.getAllMarkers();
    this.mapsCommonService.centerMapByBounds(this.map, markers);
  }

  onTaskMarkerClick(marker, eventName, markerModel) {
    this.onSelectTask({taskId: markerModel.id})
  }

  activateInfoWindow(markerModel) {
    //Data passed to info-window
    if (markerModel) {

      this.activeWindowModel = {
        id: markerModel.ref.serviceId,
        eta: markerModel.ref.analysis?.eta,
        address: markerModel.taskSpec.address,
        routeId: markerModel.ref.routeId,
        accountName: markerModel.ref.accountReference?.name,
        notBefore: markerModel.taskSpec.notBefore,
        notAfter: markerModel.taskSpec.notAfter,
        packages: _.get(markerModel.ref, 'packageList[0].items', []),
        tagNames: markerModel.ref.serviceInfo?.tagNames,
        skills: markerModel.ref.serviceInfo?.requiredSkills,
        stopType: markerModel.taskSpec.purpose,
        phoneNumber: markerModel.ref.accountReference?.phoneNumber,
        contactName: markerModel.taskSpec.contact.fullName
      };
      this.activeWindow.coords = markerModel.coords
      this.activeWindow.show = true;
    }

    this.activeWindowModel;
  }

  clearActiveWindow() {
    this.activeWindow.show = false;
    this.activeWindow.coords = undefined;
    this.activeWindowModel = undefined;
  }

  // onToggleServiceAreas() {
  //
  // }

  // ******************************
  //        Internal methods
  // ******************************
  private setSuggestedTasks(services) {
    const tasks = _.flatMap(services, (service) => {
      return service.taskList;
    });
    this.suggestionsMarkers = this.createSuggestionMarkers(tasks);
  }

  private createSuggestionMarkers(tasks, selectedServiceIds?) {
    return this.mapsCommonService.getUnroutedTaskMarkers(tasks, selectedServiceIds);
  }

  private _getPolylinePath(markers) {
    let path = [];
    _.forEach(markers, (marker) => {
      path.push(
        {
          latitude: marker.coords.latitude,
          longitude: marker.coords.longitude
        }
      )
    });
    return path;
  }

  private initItinerary(doFit?) {
    const taskMarkers = this.mapsCommonService.getRoutedTaskMarkersWithStatus(this.tasks, this.filters.tasks, this.isEditable);
    // var taskMarkers = _createTaskMarkers(this.tasks);
    this.taskMarkers = taskMarkers;
    this.polyline.path = this._getPolylinePath(taskMarkers);

    if (doFit) {
      this.centerMap();
    }
  }

  private isHeadingOrArrivedOrderCurrect(taskMarkers) {
    let taskHeadingLastIndex: any = -1;
    let regularTaskFirstIndex: any = -1;

    _.forEach(taskMarkers, (taskMarker, index) => {
      if (this.isTaskHeadingOrArrived(taskMarker)) {
        taskHeadingLastIndex = index;
      } else if (regularTaskFirstIndex === -1) {
        regularTaskFirstIndex = index
      }
    });
    return regularTaskFirstIndex > taskHeadingLastIndex;
  }

  private isTaskHeadingOrArrived(task: TaskModel) {
    return _.isEqual(task.status, 'CourierHeading') || _.isEqual(task.status, 'CourierArrived');
  }

  private getPolylinePath(allMarkers) {
    let path = [];
    _.forEach(allMarkers, function (marker) {
      path.push(
        {
          latitude: marker.coords.latitude,
          longitude: marker.coords.longitude,
          id: marker.id
        }
      )
    });
    return path;
  }

  private getAllMarkers() {
    return this.taskMarkers.concat(this.agent || [])
  }

}

angular
  .module('bringoz.admin.map')
  .component('routeMap', {
    bindings: {
      tasks: '<',
      agent: '<',
      suggestedServices: '<?',
      selectedTaskId: '<',
      selectedSuggestionIds: '<?',
      polylineColor: '<',
      serviceAreas: '<?',
      isEditable: '<?',
      onSelectTask: '&',
      onSelectSuggestion: '&',
      onChange: '&'
    },
    template: require('./route-map.html').default,
    controller: RouteMapComponent
  });

